var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewBackOfficeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#NewBackOfficeIcon_svg__clip0_3802_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 22.945c-2.519 0-5 2.427-5 6a2 2 0 01-4 0c0-3.427 1.605-6.63 4.164-8.448a6 6 0 119.673 0C24.394 22.315 26 25.518 26 28.945a2 2 0 01-4 0c0-3.573-2.481-6-5-6zm0-4a2 2 0 100-4 2 2 0 000 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 40.945a8 8 0 008-8v-24a8 8 0 00-8-8H4a4 4 0 00-4 4v32a4 4 0 004 4h22zm4-8a4 4 0 01-4 4H4v-32h22a4 4 0 014 4v24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 10.945a2 2 0 10-4 0v12a2 2 0 004 0v-12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NewBackOfficeIcon_svg__clip0_3802_1027"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .945)",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgNewBackOfficeIcon;